const TabsContent = ({ data }: any) => {
  return <div className="h-full flex-1 mt-3">{data}</div>;
};

export default TabsContent;
